import { withPazeRadioProps } from 'viewModel/checkout/sections/payment/section/pazeRadio/withPazeRadioProps';
import PaymentRadio from 'components/Checkout/Sections/Payment/Section/PaymentRadio';

export default withPazeRadioProps(PaymentRadio);
